export default "<td><%= model.get('entry') %></td>"